export const FENESTRATION_TYPES = ['window', 'door', 'balcony_door', 'entrance_door'] as const
export type ShutterConfiguration = {
  electric: boolean
  controlSide: 'left' | 'right' | null
  boxRequired: boolean
  boxHeightMm: number | null
  boxFacing: 'inside' | 'outside' | null
}
export const emptyShutter = (): ShutterConfiguration => ({ electric: false, controlSide: null, boxRequired: false, boxHeightMm: null, boxFacing: null })
export function associatedLabel(record: Record<string, unknown>): string | null {
  try { const value = JSON.parse(String(record.configurationJson || '{}')).associatedOpeningLabel; return typeof value === 'string' ? value : null } catch { return null }
}
export function normalizeShutter(value: Partial<ShutterConfiguration> = {}, current = emptyShutter()): ShutterConfiguration {
  const result = { ...current, ...value }
  if (typeof result.electric !== 'boolean' || typeof result.boxRequired !== 'boolean') throw new Error('Shutter flags must be boolean values.')
  if (!['left', 'right'].includes(result.controlSide || '')) throw new Error('Choose the shutter Motor/Strap side, viewed from inside.')
  if (!result.boxRequired) return { ...result, boxHeightMm: null, boxFacing: null }
  const boxHeightMm = result.boxHeightMm == null ? 0 : result.boxHeightMm
  if (!Number.isInteger(boxHeightMm) || Number(boxHeightMm) < 0) throw new Error('Shutter box height must be zero or a positive whole number.')
  if (!['inside', 'outside'].includes(result.boxFacing || '')) throw new Error('Choose Inside or Outside for the shutter box facing.')
  return { ...result, boxHeightMm }
}
export function readShutter(record: Record<string, unknown>): ShutterConfiguration {
  return {
    electric: record.shutterElectric === true,
    controlSide: record.shutterControlSide === 'left' || record.shutterControlSide === 'right' ? record.shutterControlSide : null,
    boxRequired: record.shutterBoxRequired === true,
    boxHeightMm: record.shutterBoxRequired === true && typeof record.shutterBoxHeightMm === 'number' ? record.shutterBoxHeightMm : 0,
    boxFacing: record.shutterBoxRequired === true && (record.shutterBoxFacing === 'inside' || record.shutterBoxFacing === 'outside') ? record.shutterBoxFacing : null,
  }
}
export function shutterFields(shutter = emptyShutter()) {
  return { shutterElectric: shutter.electric, shutterControlSide: shutter.controlSide, shutterBoxRequired: shutter.boxRequired,
    shutterBoxHeightMm: shutter.boxRequired ? (shutter.boxHeightMm ?? 0) : null, shutterBoxFacing: shutter.boxRequired ? shutter.boxFacing : null }
}
export function shutterValid(shutter: ShutterConfiguration) { try { normalizeShutter(shutter); return true } catch { return false } }
export function shutterSummary(shutter = emptyShutter()) {
  return `${shutter.electric ? 'Electric · Motor' : 'Manual · Strap'} side: ${shutter.controlSide || 'not configured'}${shutter.boxRequired ? ` · Box: ${shutter.boxHeightMm ?? '?'} mm / ${shutter.boxFacing ?? '?'}` : ' · No box'}`
}
export function productTypes(value: unknown): string[] {
  return Array.isArray(value) ? value.map(String) : typeof value === 'string' ? value.split(',').map((v) => v.trim()).filter(Boolean) : []
}
export function colorApplies(option: { productTypes?: unknown }, elementType: string | null) {
  const types = productTypes(option.productTypes)
  if (elementType === 'mosquito_net') return types.includes('mosquito_net')
  return types.includes(elementType || 'window') || (elementType !== 'shutter' && !types.length)
}
export type ProcurementScope = 'fenestration' | 'shutters' | 'mosquito_nets'
export const PROCUREMENT_SCOPES: readonly ProcurementScope[] = ['fenestration', 'shutters', 'mosquito_nets']

export function procurementScope(type: unknown): ProcurementScope | null {
  return type === 'shutter' ? 'shutters' : type === 'mosquito_net' ? 'mosquito_nets' : FENESTRATION_TYPES.some((value) => value === type) ? 'fenestration' : null
}
